// packages/shared/src/constants/ptAdlDefaults.ts
// Default ADL and IADL flow sheet catalog items for Physical Therapy.

import type { FlowSheetItemCatalogEntry } from '../types/models/flowSheet';

const ts = 0;

function entry(
  id: string,
  label: string,
  category: 'adl' | 'iadl',
  opts: Partial<FlowSheetItemCatalogEntry> = {}
): FlowSheetItemCatalogEntry {
  return {
    id,
    organization_id: 'system',
    label,
    data_type: 'select',
    category,
    is_active: true,
    created_at: ts,
    updated_at: ts,
    ...opts,
  };
}

const ASSIST_LEVEL_OPTIONS = [
  'Independent', 'Modified Independent', 'Set up/Clean up', 'Supervision/Verbal cueing',
  'Contact guard assistance', 'Minimal assistance', 'Moderate assistance', 'Maximum assistance',
  'Dependent', 'Not applicable', 'Unknown',
];

// ── Activities of Daily Living ─────────────────────────────────────────

export const PT_ADL_DEFAULTS: FlowSheetItemCatalogEntry[] = [
  entry('adl_bathing', 'Bathing / Showering', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_upper_dressing', 'Upper Body Dressing', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_lower_dressing', 'Lower Body Dressing', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_grooming', 'Grooming / Personal Hygiene', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_toileting', 'Toileting', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_continence', 'Continence Management', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_feeding', 'Feeding', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('adl_socks_shoes', 'Donning/Doffing Socks/Shoes', 'adl', { select_options: ASSIST_LEVEL_OPTIONS }),
];

// ── Instrumental Activities of Daily Living ─────────────────────────────

export const PT_IADL_DEFAULTS: FlowSheetItemCatalogEntry[] = [
  entry('iadl_meal_prep', 'Meal Preparation', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_laundry', 'Laundry', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_cleaning', 'Cleaning', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_medication', 'Medication Management', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_finances', 'Managing Finances', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_transportation', 'Transportation', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_shopping', 'Shopping', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_communication', 'Communication/Technology Management', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
  entry('iadl_community_mobility', 'Community Mobility', 'iadl', { select_options: ASSIST_LEVEL_OPTIONS }),
];
